import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Experiences = lazy(() => import("@/pages/Events"));

export const Route = createFileRoute("/experiences/")({
  component: Experiences,
});
